import { useRouter } from 'next/router'
import React, { useCallback, useRef } from 'react'
import { useClickAway } from 'react-use'
import { useComparator } from '../../../hooks/useComparator'
import { InternalLink } from '../../const/Links'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgFemale from '../../svg/icons/Female'
import SvgMale from '../../svg/icons/Male'
import { useActiveDog } from '../../user/ActiveDogContext'
import { useAuth } from '../../user/UserContext'
import { Button } from './Button'
import style from './UserMenu.module.sass'

type UserMenuProps = {
	close: () => void
}

export const UserMenu = React.memo(function UserMenu(props: UserMenuProps) {
	const auth = useAuth()
	const translate = useTranslate()
	const { dog } = useActiveDog()
	const router = useRouter()
	const { removeAll } = useComparator()
	const onClick = useCallback(() => {
		props.close()
		auth.signOut()
		removeAll()
		if (router.asPath.includes('step=2')) {
			auth.signOut().then(() => (window.location.href = InternalLink.Wizard))
			removeAll()
		}
		if (router.asPath.includes(InternalLink.MyResults)) {
			auth.signOut().then(() => (window.location.href = InternalLink.Results))
			removeAll()
		}
	}, [auth, props, removeAll, router])

	const ref = useRef(null)

	useClickAway(ref, () => {
		props.close()
	})
	const mostRecentDog =
		auth.status === 'signedIn'
			? auth.user.dogs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0]
			: null

	return (
		<div className={style.root} ref={ref}>
			<div className={style.mail}>
				{auth.status === 'signedIn' && auth.user?.email ? auth.user.email : undefined}
				{auth.status === 'signedIn' && mostRecentDog && (
					<div className={style.dogInfo}>
						<div className={style.genderIcon}>{mostRecentDog.gender === 'female' ? <SvgFemale /> : <SvgMale />}</div>
						<div>
							<span>{mostRecentDog.breed?.name}</span>,{' '}
							<span className={style.age}>{mostRecentDog.age?.label?.split(' (')[0].toLowerCase()}</span>
						</div>
					</div>
				)}
				{dog && (
					<div className={style.resultButtonWrapper}>
						<Button
							label={translate('header.button.results')}
							url={InternalLink.MyResults}
							type={{ small: true }}
							aria-label="výsledky pro mého psa"
						/>
					</div>
				)}
			</div>
			<div className={style.buttonWrapper}>
				<Button
					label={translate('header.button.signOut')}
					onClick={onClick}
					aria-label="odhlásit"
					type={{ variant: 'naked' }}
				/>
			</div>
		</div>
	)
})
